export default __webpack_public_path__ + "static/media/markerZypBike1.847f4445.svg";